import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import * as actions from '../../actions';

const styles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12
	},
	textField: {
		width: '100%'
	},
	button: {
		marginTop: '8px'
	}
};

class LoginForm extends React.Component {
	constructor(props) {
		super(props);

		this.history = this.props.history;
	}

	state = {
		canSubmit: false,
		email: '',
		password: ''
	};

	disableButton = () => {
		this.setState({ canSubmit: false });
	};

	enableButton = () => {
		this.setState({ canSubmit: true });
	};

	handleChange = name => event => {
		this.setState(
			{
				[name]: event.target.value
			},
			() => {
				if (this.state.email && this.state.password) {
					return this.enableButton();
				}
				return this.disableButton();
			}
		);
	};

	submitLoginUserForm = () => {
		const { email, password } = this.state;
		const user = { email, password };

		this.props.loginUser(user, this.history);
	};

	handleSubmit = event => {
		event.preventDefault();
		if (!this.state.canSubmit) return;
		this.submitLoginUserForm();
	};

	render() {
		return (
			<div>
				<form
					style={styles.container}
					noValidate
					autoComplete="on"
					onSubmit={this.handleSubmit}
				>
					<TextField
						id="email"
						label="Email"
						type="email"
						style={styles.textField}
						onChange={this.handleChange('email')}
						variant="outlined"
						size="small"
						autoComplete="email"
						autoFocus
					/>
					<TextField
						id="password"
						label="Password"
						style={styles.textField}
						type="password"
						onChange={this.handleChange('password')}
						variant="outlined"
						size="small"
						autoComplete="current-password"
					/>
					<div>
						<Button
							disabled={!this.state.canSubmit}
							size="large"
							variant="contained"
							color="primary"
							style={styles.button}
							type="submit"
							fullWidth
						>
							Log in
						</Button>
					</div>
				</form>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		error: state.error
	};
}

export default connect(
	mapStateToProps,
	actions
)(withRouter(LoginForm));



// WEBPACK FOOTER //
// ./src/components/register/LoginForm.js